import { SearchResult } from 'functions/src/types/firestore/Search';
import { AvatarNext } from 'src/components/AvatarNext';
import { SearchResultBase } from './SearchResultBase';
import { toKebabCase } from 'src/util/string';

export type ReviewSearchResultProps = SearchResult & { category: 'review' };

export const ReviewSearchResult = ({
  review,
  title,
  description,
}: ReviewSearchResultProps) => {
  return (
    <SearchResultBase
      href={`/game/${toKebabCase(review.gameId)}/reviews`}
      imageSx={{
        display: 'flex',
        flexGrow: 0,
        minWidth: 90,
        minHeight: 90,
        borderRadius: '4px',
      }}
      image={
        <AvatarNext
          variant="gradientOutlined"
          src={review.imgUrl}
          alt=""
          sx={{ width: 90, height: 90 }}
        />
      }
      header={title}
      headerSx={{
        display: '-webkit-box',
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
      }}
      description={description}
      category="Review"
    />
  );
};
